import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card } from "@mantine/core";
import { useParams } from "react-router-dom";
import { ErrorView, PageTitle } from "@components/shared";
import {
  CalculationContainers,
  EmployeeMeta,
  SurveyMeta,
} from "@legacy/Evaluation";

import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

function personLabel(person, fallbackId) {
  if (!person) return fallbackId ? String(fallbackId) : "—";
  const name = `${person.first_name || ""} ${person.last_name || ""}`.trim();
  return name || person.email || String(fallbackId || "—");
}

export default function EvaluationDetail() {
  const [error, setError] = useState(null);
  const [assessment, setAssessment] = useState(null);
  const [scoring, setScoring] = useState(null);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    fetchData();
  }, [id]);

  function fetchData() {
    axios
      .get(`/assessments/${id}/`)
      .then(({ data }) => {
        const row = data.response?.[0] || null;
        setAssessment(row);
        setError(null);
        if (!row) return null;
        return axios
          .get(`/assessments/${id}/scoring-result/`)
          .then((scoringRes) => {
            setScoring(scoringRes.data.response?.[0] || null);
          })
          .catch(() => setScoring(null));
      })
      .catch((err) => {
        setError(err);
        setAssessment(null);
        setScoring(null);
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!assessment) return null;

  const user = assessment.user;
  const orgId = assessment.organization_id;
  const displayName = personLabel(user, assessment.user_id);

  return (
    <div>
      <PageTitle
        title={`Evaluation for ${displayName}`}
        icon={entityIcon.evaluation()}
        iconColor={entityColor.evaluation}
      />
      <Card mt="lg">
        <EmployeeMeta
          name={displayName}
          email={user?.email}
          id={user?.id}
          employeeId={user?.id}
          companyName={orgId}
          companyId={orgId}
        />
      </Card>
      <Card mt="lg">
        <SurveyMeta
          name={
            assessment.assessment_instrument?.name || assessment.name || "—"
          }
          submitted={
            assessment.submitted_at
              ? new Date(assessment.submitted_at).toLocaleString()
              : "—"
          }
        />
      </Card>
      <Card mt="lg">
        <CalculationContainers
          assessment={assessment}
          organizationId={orgId}
          scoringResultId={scoring?.id}
          fetchData={fetchData}
        />
      </Card>
    </div>
  );
}
